import { StrictMode } from 'react';
import './environment';
import './reset.css';

import './styles.css';

import './app/utils/i18n';

import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

import App from './app/app';
import { AppErrorBoundary } from './app/AppErrorBoundary';
import { initReporting } from './reporting/reporting';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

import { ThemeProvider } from '@teamworksdev/mui';

const icons = {
  dropdown: ExpandMoreIcon,
  success: CheckCircleIcon,
  info: InfoIcon,
  warning: WarningIcon,
  error: ErrorIcon,
};

initReporting();

export default function Root() {
  return (
    <StrictMode>
      <StyledEngineProvider injectFirst>
        <ThemeProvider icons={icons}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <AppErrorBoundary>
              <App />
            </AppErrorBoundary>
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </StrictMode>
  );
}
